import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { fetchModuleMenu, setSelectedModuleGroup, resetFilters, selectSelectedModuleGroup, selectLoading } from '../store/slices/modulemenuSlice';
import axios from 'axios';
import { getSalesReactBaseUrl } from '../utilities/api';
import './CategoryMaster.css';

const API_URL = `${getSalesReactBaseUrl()}/api/server_masters`;

const ModuleMenuHeader = () => {
    const dispatch = useDispatch();
    const selectedModuleGroup = useSelector(selectSelectedModuleGroup);
    const loading = useSelector(selectLoading);

    const [groupOptions, setGroupOptions] = useState([]);

    useEffect(() => {
        dispatch(fetchModuleMenu());
        axios
            .get(`${API_URL}/getModuleGroups`)
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setGroupOptions(res.data.map((g) => ({ label: g.module_group_name, value: g.module_group_id })));
                }
            })
            .catch(() => {});
    }, [dispatch]);

    const handleApplyFilters = () => {
        dispatch(fetchModuleMenu());
    };

    const handleResetFilters = () => {
        dispatch(resetFilters());
        dispatch(fetchModuleMenu());
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Module Menus
                </h2>
                <p className="text-color-secondary">Browse and manage module menus filtered by module group</p>
            </div>

            <Card className="mb-4 bill-reports-filter-card">
                <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label htmlFor="moduleGroup" className="mb-2 font-medium text-sm">
                            Module Group
                        </label>
                        <Dropdown id="moduleGroup" value={selectedModuleGroup} options={groupOptions} onChange={(e) => dispatch(setSelectedModuleGroup(e.value))} placeholder="Select Module Group" className="w-full" filter showClear />
                    </div>

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Apply Filters" icon="pi pi-check" className="p-button-primary" onClick={handleApplyFilters} disabled={loading} loading={loading} />
                        <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleResetFilters} />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default ModuleMenuHeader;
